import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servics',
  templateUrl: './servics.component.html',
  styleUrls: ['./servics.component.css']
})
export class ServicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
